import { DataRegistryService } from "../data-registry.service";

export class DataRegistryInspectorSession {

    constructor (private ds: DataRegistryService) {}

    async startSession () {
        
    }

}